/* @flow */
import ChatMessage from 'entities/ChatMessage';
import cx from 'classnames';
import { connect } from 'react-redux';
import Hovercard from 'components/Hovercard.jsx';
import HovercardBody from 'components/HovercardBody.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import React from 'react';
import ReactionEmojis from 'collections/ReactionEmojis';
import ShortcodeEmoji from 'components/ShortcodeEmoji.jsx';

import './styles/ReactionButton.scss';

type Props = {
  message: ChatMessage,
  className?: ?string,
  reactions: ?ReactionEmojis,
  onShow?: ?Function,
  onHide?: ?Function
};

export class ReactionButton extends React.Component {
  props: Props;

  _layerPicker = null;

  onShow = () => {
    if (this.props.onShow) {
      this.props.onShow();
    }
  };

  onHide = () => {
    if (this.props.onHide) {
      this.props.onHide();
    }
  };

  render() {
    const { message, reactions } = this.props;

    if (!reactions) {
      return null;
    }

    const reactionPicker = (
      <Hovercard
        className="ReactionButton-picker"
        hideOnEscape
        hideOnBlur>
        <HovercardBody className="ReactionButton-picker-body">
          {reactions && reactions.map(reaction => {
            return (
              <Link
                key={reaction.getName()}
                className="ReactionButton-picker-body-emoji"
                onClick={() => {
                  if (this._layerPicker) {
                    this._layerPicker.hideLayer();
                  }
                  message.addReaction(reaction.getName());
                }}
                eventElementName="ReactionButton-picker-body-emoji">
                <ShortcodeEmoji text={reaction.getEmojiCode()} />
              </Link>
            );
          })}
        </HovercardBody>
      </Hovercard>
    );

    return (
      <LayerTrigger
        className={cx('ReactionButton', this.props.className)}
        layer={reactionPicker}
        ref={(layerPicker) => (this._layerPicker = layerPicker)}
        trigger="click"
        alignment="right"
        placement="top"
        onShow={this.onShow}
        onHide={this.onHide}
        hideLayerOnScroll>
        <Link>
          <Image src={require('assets/images/add-reaction.svg')} />
        </Link>
      </LayerTrigger>
    );
  }
}

const mapStateToProps = (state: Object) => {
  return {
    reactions: state.availableReactions.availableReactions,
  };
};

export default connect(mapStateToProps)(ReactionButton);



// WEBPACK FOOTER //
// ./src/chat/components/ReactionButton.jsx